import type { Entity } from "shelving";
import { useState } from "react";
import { REMOVE_LIST_ITEM } from "shared/api";
import { type CreatorEntity, PRIVATE_PRIVACIES } from "shared/schema";
import { CreatorInput } from "../create/CreatorField.js";
import { callAPIWithNotice } from "../util/api.js";
import { USER } from "../util/user.js";
import { ListPicker } from "./ListPicker.js";

export function ListRemovePicker({ item }: { item: Entity }): React.ReactElement {
	const [creator, setCreator] = useState<CreatorEntity>(`profile:${USER.data.uid}`);
	return (
		<>
			<h2>Remove from list</h2>
			<ListPicker //
				query={{ "creator": creator, "privacy": PRIVATE_PRIVACIES, "items[]": item, "$order": "name" }}
				onPick={lid => callAPIWithNotice(REMOVE_LIST_ITEM, { id: lid, item })}
				empty={<div className="input input-placeholder">No lists</div>}
			/>
			<CreatorInput value={creator} onChange={setCreator} mods="size-small pad-none align-right width-fit" />
		</>
	);
}
